import { MODULES } from "#constants/modules"
import DescriptionIcon from "@mui/icons-material/Description"
import Index from "./pages/Index"

export const URLS = {
	"Documentación": [
		{
			module: MODULES.DOCUMENTOS,
			path: "Documentation",
			element: <Index />,
			title: "Documentación",
			icon: DescriptionIcon ,
			permissions: [],
			textDivider: "Documentación",
		},
	],
}
